<template>
  <el-menu
    :default-active="defaultActiveMenuItem"
    :default-openeds="defaultOpeneds.length ? defaultOpeneds : (config.defaultOpeneds || config['default-openeds'])"
    pagoda-layout-menu
    v-bind="config"
    ref="elMenu"
  >
    <template v-for="(item, index) in data">
      <sub-menu
        v-if="item[subMenuKey] && item[subMenuKey].length"
        :labelKey="labelKey"
        :subMenuKey="subMenuKey"
        :urlKey="urlKey"
        :iconKey="iconKey"
        :node="item"
        :index="`${index}`"
        :handleItemClick="handleItemClick"
      ></sub-menu>
      <el-menu-item
        v-else
        :index="`${index}`"
        :node="item"
        :disabled="item.disabled"
        @click="handleItemClick(item)"
      >
        <i v-if="item[iconKey]" class="pagoda-layout-sidemenu-icon" :class="item[iconKey]"></i>
        <template slot="title">
          <span >{{item[labelKey]}}</span>
        </template>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
  import {
    getEmptyArray,
    getEmptyObject,
    noop
  } from "../../../utils";

  import {
    getMathUrlCollection
  } from '../../../utils/url'

  import SubMenu from './sub-menu'

  export default {
    inheritAttrs: false,
    props: {
      data: {
        type: Array,
        default: getEmptyArray
      },
      config: {
        type: Object,
        default: getEmptyObject
      },
      openTab: {
        type: Function,
        default: noop
      },
      defaultActive: String,
      labelKey: String,
      subMenuKey: String,
      urlKey: String,
      iconKey: String
    },
    provide () {
      return {
        pagodaSideMenuInstance: this
      }
    },
    data () {
      return {
        defaultOpeneds: [],
        defaultActiveMenuItem: ''
      }
    },
    methods: {
      handleItemClick (item) {
        this.$emit('item-click', item)
      },
      getDefaultActiveMenu (menu) {
        const subMenus = menu.$children
        const fullPath = this.defaultActive.split('?')[0]
        const mathUrlCollection = getMathUrlCollection(fullPath)

        for(const subMenu of subMenus){

          if(
            subMenu.$attrs.node &&
            subMenu.$attrs.node[this.urlKey] &&
            subMenu.$options.name === 'ElMenuItem'
          ){
            const _mathUrlCollection = subMenu.$attrs.node.pathMatchFull ? [fullPath] : mathUrlCollection

            if (_mathUrlCollection.includes(subMenu.$attrs.node[this.urlKey])) return subMenu
          } else if (subMenu.$options.name !== 'ElMenuItem') {
            const getDefaultActiveMenu = this.getDefaultActiveMenu(subMenu)

            if(getDefaultActiveMenu) return getDefaultActiveMenu
          }
        }
      },
      setDefaultActiveMenu () {
        const {
          elMenu
        } = this.$refs
        const defaultActiveMenu = this.getDefaultActiveMenu(this)

        if(defaultActiveMenu) {
          const defaultActivePath = defaultActiveMenu.indexPath
          // this.defaultOpeneds = defaultActivePath.slice(0, defaultActivePath.length - 1)
          this.defaultActiveMenuItem = elMenu.activeIndex = defaultActivePath[defaultActivePath.length - 1]

          if (!this.$route.meta.tabConfig) {
            this.openTab({
              ...this.$route,
              ...defaultActiveMenu.$attrs.node,
              [this.urlKey]: this.defaultActive
            })
          }
        } else {
          // 重置
          // this.defaultOpeneds = []
          this.defaultActiveMenuItem = ''
          elMenu.activeIndex = null
        }
      }
    },
    watch: {
      defaultActive: {
        immediate: true,
        handler () {
          this.$nextTick(this.setDefaultActiveMenu)
        }
      }
    },
    components: {
      SubMenu
    }
  }
</script>
